import { useState } from "react";
import { Drawer, Stack, Text, Button, Divider, UnstyledButton, Group, Box } from "@mantine/core";
import { IconMenu2, IconX } from "@tabler/icons-react";
import { Link, useLocation } from "react-router-dom";

type MobileHamburgerProps = {
  isAuthenticated: boolean;
};

export default function MobileHamburger({ isAuthenticated }: MobileHamburgerProps) {
  const [opened, setOpened] = useState(false);
  const location = useLocation();

  const close = () => setOpened(false);

  const NavItem = ({ to, label, external }: { to: string; label: string; external?: boolean }) =>
    external ? (
      <UnstyledButton component="a" href={to} target="_blank" rel="noopener noreferrer" onClick={close} style={{ padding: "10px 12px", borderRadius: 8 }}>
        <Text fw={500} c="dark">{label}</Text>
      </UnstyledButton>
    ) : (
      <UnstyledButton
        component={Link}
        to={to}
        onClick={close}
        style={{
          padding: "10px 12px",
          borderRadius: 8,
          background: location.pathname === to ? "#EEF4FF" : "transparent",
        }}
      >
        <Text fw={location.pathname === to ? 600 : 500} c={location.pathname === to ? "primary.6" : "dark"}>
          {label}
        </Text>
      </UnstyledButton>
    );

  return (
    <>
      {/*  Hamburger icon */}
      <UnstyledButton onClick={() => setOpened(true)} hiddenFrom="sm">
        <IconMenu2 size={26} />
      </UnstyledButton>

      {/*  Mobile Drawer */}
      <Drawer opened={opened} onClose={close} padding="lg" size="100%" position="left" withCloseButton={false}>
        {/* Header */}
        <Group justify="space-between" mb="md">
          <Text fw={700} size="lg" c="primary.6">
            GTsetu
          </Text>
          <UnstyledButton onClick={close}>
            <IconX size={22} />
          </UnstyledButton>
        </Group>

        <Stack gap="xs">
          {isAuthenticated ? (
            <>
              {/* Logged-in menu */}
              <NavItem to="/profile" label="My Profile" />
              <NavItem to="/" label="Discover" />
              <NavItem to="/requests" label="Interests" />
              <NavItem to="/collaborations" label="Collaborations" />
              <NavItem to="/shortlist" label="Shortlist" />
              <NavItem to="/invoices" label="Invoices" />
              <NavItem to="/support" label="Support" />
            </>
          ) : (
            <>
              {/* Public menu */}
              <NavItem to="/" label="Find Partner" />
              <NavItem to="https://gtsetu.com/features/" label="Features" external />
              <NavItem to="https://gtsetu.com/pricing/" label="Pricing" external />
              <NavItem to="https://gtsetu.com/support/" label="Support" external />

              <Divider my="md" />

              <Box>
                <Button component={Link} to="/login" fullWidth radius="md" mb="sm" onClick={close}>
                  Log In
                </Button>
                <Button component={Link} to="/signup" fullWidth variant="outline" radius="md" onClick={close}>
                  Sign Up
                </Button>
              </Box>
            </>
          )}
        </Stack>
      </Drawer>
    </>
  );
}
